import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { getVisitorId, getSessionInfo, readUtmFromUrl, captureFirstTouch } from "@/lib/attribution";

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;
    captureFirstTouch(path);
    const visitor_id = getVisitorId();
    const { session_id, is_entry } = getSessionInfo();
    const utm = readUtmFromUrl();
    // Give the document a moment to set its title for accurate entry-page labels.
    const send = () =>
      api
        .post("/track/pageview", {
          path,
          visitor_id,
          session_id,
          is_entry,
          title: (document.title || "").slice(0, 200),
          referrer: document.referrer || "",
          ...utm,
        })
        .catch(() => {});
    const timer = setTimeout(send, 150);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}
